import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	trialDayHeading: {
		id: 'signup.upsell.extendedTrialSubHeading',
		defaultMessage: 'Start your free {amount}-{quantity, plural, one {day} other {day}} {br}trial',
		description: 'Signup for a free trial for a number amount of days',
	},
	trialMonthHeading: {
		id: 'signup.upsell.extendedTrialMonthSubheading',
		defaultMessage: 'Start your free {amount}-{quantity, plural, one {month} other {month}} {br} trial',
		description: 'Signup for a free trial for a number of months',
	},
	freeTrialSubheading: {
		id: 'redesign.purchase.purchaseForm.simpleHomepageSectionOneCopy',
		defaultMessage: 'No commitment. Cancel anytime.',
		description: 'Payment form subheading if user has free trial coupon',
	},
	fiveStars: {
		id: 'shared.sections.appStoreReviews.fiveStars',
		defaultMessage: 'Over 1,000,000 5-star reviews',
		description: 'Amount of 5 stars review Calm has',
	},
});
